export const paymentMethodType = [{
  value: 'Undefined', label: 'Undefined'
}, {
  value: 'CreditCard', label: 'CreditCard'
}];